import { Link } from 'react-router-dom';

const INDUSTRIES = [
  { icon: 'ri-ship-line', label: 'Maritime & Shipping' },
  { icon: 'ri-building-line', label: 'Real Estate' },
  { icon: 'ri-hospital-line', label: 'Healthcare' },
  { icon: 'ri-store-2-line', label: 'Retail & E-Commerce' },
  { icon: 'ri-book-2-line', label: 'Education & Libraries' },
  { icon: 'ri-building-4-line', label: 'Manufacturing' },
  { icon: 'ri-bank-line', label: 'Finance & Banking' },
  { icon: 'ri-government-line', label: 'Government' },
];

export default function HomeIndustries() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            {/* <span className="inline-block bg-teal-100 text-teal-700 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-4">
              Industries
            </span> */}
            <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900">
              Industries We Serve
            </h2>
          </div>
          <Link to="/industries" className="cursor-pointer whitespace-nowrap text-teal-600 hover:text-teal-700 font-semibold text-sm flex items-center gap-1">
            View All Industries <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {INDUSTRIES.map((ind) => (
            <Link
              key={ind.label}
              to="/industries"
              className="group flex flex-col items-center gap-3 bg-gray-50 hover:bg-teal-50 border border-gray-100 hover:border-teal-200 rounded-2xl p-6 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white text-teal-600 rounded-xl border border-gray-200 group-hover:border-teal-300 transition-colors">
                <i className={`${ind.icon} text-2xl`} />
              </div>
              <span className="text-sm font-medium text-gray-700 text-center">{ind.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
